<template>
  <div>
    <div class="input-group h-100">
      <input
        name="latitude"
        placeholder="latitude"
        v-model="latitudeData"
        class="form-control h-100"
        v-validate="{ required: true, decimal: true, between: [-90, 90] }"
      >
      <input
        name="longitude"
        placeholder="longitude"
        v-model="longitudeData"
        class="form-control h-100"
        v-validate="{ required: true, decimal: true, between: [-180, 180] }"
      >
      <button
        class="btn btn-primary h-100"
        @click="getCoordinatesSearchResult()"
      >
        Search
      </button>
    </div>
    <span class="coordinate-text-danger">{{ errors.first('latitude') }} </span>
    <span class="coordinate-text-danger">{{ errors.first('longitude') }}</span>
  </div>
</template>

<script>
import EventBus from '@/eventBus';

export default {
  data() {
    return {
      latitudeData: this.latitude,
      longitudeData: this.longitude,
    };
  },
  methods: {
    getCoordinatesSearchResult() {
      const myCoordinate = {
        latitude: this.latitudeData,
        longitude: this.longitudeData,
      };
      EventBus.$emit('coordinateSet', myCoordinate);
    },
  },
  name: 'ByCoordinate',
  props: {
    latitude: {
      type: Number,
      default: null,
      validator(value) {
        return value >= -90 && value <= 90;
      },
    },
    longitude: {
      type: Number,
      default: null,
      validator(value) {
        return value >= -180 && value <= 180;
      },
    },
  },
};
</script>
<style scoped>
.coordinate-text-danger {
  background-color: #ed1c24;
  color: #fff !important;
}

input::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  font-style: italic;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  font-style: italic;
}

::-ms-input-placeholder { /* Microsoft Edge */
  font-style: italic;
}
</style>
